import api from '../../helpers/axios'

export const state = {
    customer: null,
    customers: []
};

export const getters = {
    customer: (state) => state.customer,
    customers: (state) => state.customers,
    payments: (state) => state.payments
};

export const mutations = {
    setCustomer(state, newValue) {
        state.customer = newValue;
    },
    setCustomerPayments(state, newValue) {
        state.payments = newValue;
    },
    setCustomers(state, newValue) {
        state.customers = newValue;
    },
};

export const actions = {
    createCustomer(_,  data) {
        return new Promise((resolve,reject) => {
            api.post("/customers", data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },
    updateCustomer(_, {id,data}) {
        return new Promise((resolve,reject) => {
            api.put("/customers/"+id, data).then((res) => {
                resolve(res.data.data)
            }).catch((err) => {
                reject(err)
            })
        });
    },
    deleteCustomer(_, id) {
        return new Promise((resolve) => {
            api.delete("/customers/"+id).then((res) => {
                resolve(res.data.data)
            })
        });
    },
    fetchCustomer({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/customers/"+id).then((res) => {
                commit("setCustomer", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },

   fetchCustomers({ commit }, {page, limit,listType, ...params}) {

        let query = "?";
        if(listType){
            query+=`listType=${listType}&`
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }
       /* eslint-disable no-console */
       console.log(params)
       if(params.search){
           query += `q=${params.search}&`;
       }


        return new Promise((resolve) => {
            api.get("/customers"+query, {params}).then((res) => {
                commit("setCustomers", res.data.data);
                resolve(res.data.data)
            })
        });
    },


    fetchCustomerPayments({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/customers/"+id+'/payments').then((res) => {
                commit("setCustomerPayments", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },

    fetchCustomerSessions(_, {page, limit,id}) {

        let query = "?";
        query += `page=${page}&`;
        query += `limit=${limit}`;

        return new Promise((resolve,reject) => {
            api.get("/customer-users/"+id+'/sessions'+query).then((res) => {
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },


    fetchCustomerAgreementSessions(_, {page, limit,id}) {

        let query = "?";
        query += `page=${page}&`;
        query += `limit=${limit}`;

        return new Promise((resolve,reject) => {
            api.get("/customer-users/"+id+'/agreement-sessions'+query).then((res) => {
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },
};
